import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { SvgIcon, Flex } from 'Components/Base';
import { FeedbackReport } from 'Containers/Feedback';
import ClearByOnDemand from 'Routes/Classroom/Featured/ClearByOnDemand/Container/ClearByOnDemand';
import ClearByLearnEd from 'Routes/Classroom/Featured/ClearByLearnEd/Container/ClearByLearnEd';
import { PROVIDER_NAME } from 'Util/constants';

import InformationButton from '../Button/InformationButton';

const OnlineSolutionButton = ({ onOpenOnlineSolution }) => {
  return (
    <InformationButton
      title={'ดาวน์โหลดเฉลยละเอียด'}
      icon={SvgIcon.ICON_LIST.IMPORT_CONTACTS}
      onClick={onOpenOnlineSolution}
      mb={3}
    />
  );
};

const FeedbackReportButton = ({ onClickVideoEndingOverlayContent, ...props }) => (
  <Flex width={'100%'} {...props}>
    <InformationButton
      title={'รายงานปัญหาการใช้งาน'}
      icon={SvgIcon.ICON_LIST.REPORT}
      onClick={onClickVideoEndingOverlayContent}
      mb={6}
    />
  </Flex>
);

const InformationContent = ({
  onClickVideoEndingOverlayContent,
  onOpenOnlineSolution,
  providerName,
}) => {
  return (
    <Fragment>
      <ClearByOnDemand
        renderButton={(onClick) => (
          <InformationButton
            title="สงสัยเนื้อหาไม่เข้าใจ"
            icon={SvgIcon.ICON_LIST.HELP}
            onClick={() => {
              onClickVideoEndingOverlayContent();
              onClick();
            }}
            mb={3}
          />
        )}
      />
      <ClearByLearnEd
        onClickVideoEndingOverlayContent={onClickVideoEndingOverlayContent}
        isVideoEndingOverlayButton={true}
      />
      {providerName === PROVIDER_NAME.ONDEMAND && (
        <OnlineSolutionButton onOpenOnlineSolution={onOpenOnlineSolution} />
      )}
      <FeedbackReport
        toggleComponent={
          <FeedbackReportButton
            onClickVideoEndingOverlayContent={onClickVideoEndingOverlayContent}
          />
        }
      />
    </Fragment>
  );
};

InformationContent.propTypes = {
  providerName: PropTypes.string,
  onClickVideoEndingOverlayContent: PropTypes.func,
  onOpenOnlineSolution: PropTypes.func,
};

OnlineSolutionButton.propTypes = {
  onOpenOnlineSolution: PropTypes.func,
};

FeedbackReportButton.propTypes = {
  onClickVideoEndingOverlayContent: PropTypes.func,
};

export default InformationContent;
